import { useState } from "react";

const HelpTooltip = ({ text, position = 'top' }) => {
    const [visible, setVisible] = useState(false);
    if (!text) return null;

    const popupStyle = {
        position: 'absolute',
        zIndex: 200,
        background: '#363636',
        color: '#fff',
        fontSize: '0.75rem',
        lineHeight: 1.45,
        padding: '0.5rem 0.75rem',
        borderRadius: '4px',
        width: '260px',
        whiteSpace: 'pre-line',
        boxShadow: '0 2px 8px rgba(0,0,0,0.18)',
        pointerEvents: 'none',
        ...(position === 'top'    && { bottom: 'calc(100% + 6px)', left: '50%', transform: 'translateX(-50%)' }),
        ...(position === 'bottom' && { top:    'calc(100% + 6px)', left: '50%', transform: 'translateX(-50%)' }),
        ...(position === 'right'  && { left:   'calc(100% + 6px)', top: '50%',  transform: 'translateY(-50%)' }),
        ...(position === 'left'   && { right:  'calc(100% + 6px)', top: '50%',  transform: 'translateY(-50%)' }),
    };

    return (
        <span style={{ position: 'relative', display: 'inline-flex', alignItems: 'center', marginLeft: '0.3rem', verticalAlign: 'middle' }}>
            <span
                onMouseEnter={() => setVisible(true)}
                onMouseLeave={() => setVisible(false)}
                onFocus={() => setVisible(true)}
                onBlur={() => setVisible(false)}
                tabIndex={0}
                role="button"
                aria-label={`Help: ${text}`}
                style={{
                    cursor: 'help',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '1rem',
                    height: '1rem',
                    borderRadius: '50%',
                    background: '#dbdbdb',
                    color: '#4a4a4a',
                    fontSize: '0.65rem',
                    fontWeight: 'bold',
                    userSelect: 'none',
                    flexShrink: 0,
                    outline: 'none',
                }}
            >
                ?
            </span>
            {visible && <span style={popupStyle}>{text}</span>}
        </span>
    );
};

export default HelpTooltip;
